"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerkleDistributorFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MerkleDistributorFactory = /** @class */ (function (_super) {
    __extends(MerkleDistributorFactory, _super);
    function MerkleDistributorFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MerkleDistributorFactory.prototype.deploy = function (token_, merkleRoot_, overrides) {
        return _super.prototype.deploy.call(this, token_, merkleRoot_, overrides || {});
    };
    MerkleDistributorFactory.prototype.getDeployTransaction = function (token_, merkleRoot_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, token_, merkleRoot_, overrides || {});
    };
    MerkleDistributorFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MerkleDistributorFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MerkleDistributorFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MerkleDistributorFactory;
}(contracts_1.ContractFactory));
exports.MerkleDistributorFactory = MerkleDistributorFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "token_",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "merkleRoot_",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "active",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "switchActive",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60806040523480156200001157600080fd5b50604051620014ad380380620014ad8339818101604052810190620000379190620001e2565b336000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055503373ffffffffffffffffffffffffffffffffffffffff16600073ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a381600160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550806002819055506000600360006101000a81548160ff021916908315150217905550505062000229565b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006200016f8262000142565b9050919050565b620001818162000162565b81146200018d57600080fd5b50565b600081519050620001a18162000176565b92915050565b6000819050919050565b620001bc81620001a7565b8114620001c857600080fd5b50565b600081519050620001dc81620001b1565b92915050565b60008060408385031215620001fc57620001fb6200013d565b5b60006200020c8582860162000190565b92505060206200021f85828601620001cb565b9150509250929050565b61127480620002396000396000f3fe608060405234801561001057600080fd5b50600436106100935760003560e01c80638da5cb5b116100665780638da5cb5b146100fa5780639e34070f14610118578063bdf05ccc14610148578063f2fde38b14610152578063fc0c546a1461016e57610093565b806302fb0c5e146100985780632e7ba6ef146100b65780632eb4a7ab146100d2578063715018a6146100f0575b600080fd5b6100a061018c565b6040516100ad91906109bc565b60405180910390f35b6100d060048036038101906100cb9190610ada565b61019f565b005b6100da610425565b6040516100e79190610b7b565b60405180910390f35b6100f861042b565b005b610102610577565b60405161010f9190610ba5565b60405180910390f35b610132600480360381019061012d9190610bc0565b6105a0565b60405161013f91906109bc565b60405180910390f35b6101506105f6565b005b61016c60048036038101906101679190610bed565b6106b0565b005b61017661086b565b6040516101839190610ba5565b60405180910390f35b600360009054906101000a900460ff1681565b60011515600360009054906101000a900460ff161515146101f5576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016101ec90610c9d565b60405180910390fd5b6101fe856105a0565b1561023e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161023590610d2f565b60405180910390fd5b600085858560405160200161025593929190610db8565b6040516020818303038152906040528051906020012090506102bb838380806020026020016040519081016040528093929190818152602001838360200280828437600081840152601f19601f8201169050808301925050505050505060025483610891565b6102fa576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016102f190610e41565b60405180910390fd5b61030386610947565b600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663a9059cbb86866040518363ffffffff1660e01b8152600401610360929190610e70565b6020604051808303816000875af115801561037f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906103a39190610ec5565b6103e2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016103d990610f64565b60405180910390fd5b7f4ec90e965519d92681267467f775ada5bd214aa92c0dc93d90a5e880ce9ed02686868660405161041593929190610f84565b60405180910390a1505050505050565b60025481565b3373ffffffffffffffffffffffffffffffffffffffff1660008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16146104b9576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016104b090611007565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff1660008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a360008060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b600080610100836105b19190611085565b90506000610100846105c391906110b6565b90506000600460008481526020019081526020016000205490506000826001901b90508081831614945050505050919050565b3373ffffffffffffffffffffffffffffffffffffffff1660008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614610684576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161067b90611007565b60405180910390fd5b600360009054906101000a900460ff1615600360006101000a81548160ff021916908315150217905550565b3373ffffffffffffffffffffffffffffffffffffffff1660008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff161461073e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161073590611007565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1614156107ae576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016107a590611159565b60405180910390fd5b8073ffffffffffffffffffffffffffffffffffffffff1660008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a3806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050565b600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b60008082905060005b85518110156109395760008682815181106108b8576108b7611179565b5b602002602001015190508083116108f95782816040516020016108dc9291906111c9565b604051602081830303815290604052805190602001209250610925565b808360405160200161090c9291906111c9565b6040516020818303038152906040528051906020012092505b508080610931906111f5565b91505061089a565b508381149150509392505050565b6000610100826109579190611085565b905060006101008361096991906110b6565b9050806001901b6004600084815260200190815260200160002054176004600084815260200190815260200160002081905550505050565b60008115159050919050565b6109b6816109a1565b82525050565b60006020820190506109d160008301846109ad565b92915050565b600080fd5b600080fd5b6000819050919050565b6109f4816109e1565b81146109ff57600080fd5b50565b600081359050610a11816109eb565b92915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000610a4282610a17565b9050919050565b610a5281610a37565b8114610a5d57600080fd5b50565b600081359050610a6f81610a49565b92915050565b600080fd5b600080fd5b600080fd5b60008083601f840112610a9a57610a99610a75565b5b8235905067ffffffffffffffff811115610ab757610ab6610a7a565b5b602083019150836020820283011115610ad357610ad2610a7f565b5b9250929050565b600080600080600060808688031215610af657610af56109d7565b5b6000610b0488828901610a02565b9550506020610b1588828901610a60565b9450506040610b2688828901610a02565b935050606086013567ffffffffffffffff811115610b4757610b466109dc565b5b610b5388828901610a84565b92509250509295509295909350565b6000819050919050565b610b7581610b62565b82525050565b6000602082019050610b906000830184610b6c565b92915050565b610b9f81610a37565b82525050565b6000602082019050610bba6000830184610b96565b92915050565b600060208284031215610bd657610bd56109d7565b5b6000610be484828501610a02565b91505092915050565b600060208284031215610c0357610c026109d7565b5b6000610c1184828501610a60565b91505092915050565b600082825260208201905092915050565b7f4d65726b6c654469737472696275746f723a20436f6e7472616374206973206e60008201527f6f74206163746976650000000000000000000000000000000000000000000000602082015250565b6000610c87602983610c1a565b9150610c9282610c2b565b604082019050919050565b60006020820190508181036000830152610cb681610c7a565b9050919050565b7f4d65726b6c654469737472696275746f723a2044726f7020616c72656164792060008201527f636c61696d656400000000000000000000000000000000000000000000000000602082015250565b6000610d19602783610c1a565b9150610d2482610cbd565b604082019050919050565b60006020820190508181036000830152610d4881610d0c565b9050919050565b6000819050919050565b610d6a610d65826109e1565b610d4f565b82525050565b60008160601b9050919050565b6000610d8882610d70565b9050919050565b6000610d9a82610d7d565b9050919050565b610db2610dad82610a37565b610d8f565b82525050565b6000610dc48286610d59565b602082019150610dd48285610da1565b601482019150610de48284610d59565b602082019150819050949350505050565b7f4d65726b6c654469737472696275746f723a20496e76616c69642070726f6f66600082015250565b6000610e2b602083610c1a565b9150610e3682610df5565b602082019050919050565b60006020820190508181036000830152610e5a81610e1e565b9050919050565b610e6a816109e1565b82525050565b6000604082019050610e856000830185610b96565b610e926020830184610e61565b9392505050565b610ea2816109a1565b8114610ead57600080fd5b50565b600081519050610ebf81610e99565b92915050565b600060208284031215610edb57610eda6109d7565b5b6000610ee984828501610eb0565b91505092915050565b7f4d65726b6c654469737472696275746f723a205472616e73666572206661696c60008201527f6564000000000000000000000000000000000000000000000000000000000000602082015250565b6000610f4e602283610c1a565b9150610f5982610ef2565b604082019050919050565b60006020820190508181036000830152610f7d81610f41565b9050919050565b6000606082019050610f996000830186610e61565b610fa66020830185610b96565b610fb36040830184610e61565b949350505050565b7f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572600082015250565b6000610ff1602083610c1a565b9150610ffc82610fbb565b602082019050919050565b6000602082019050818103600083015261102081610fe4565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b6000611090826109e1565b915061109b836109e1565b9250826110ab576110aa611027565b5b828204905092915050565b60006110c1826109e1565b91506110cc836109e1565b9250826110dc576110db611027565b5b828206905092915050565b7f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160008201527f6464726573730000000000000000000000000000000000000000000000000000602082015250565b6000611143602683610c1a565b915061114e826110e7565b604082019050919050565b6000602082019050818103600083015261117281611136565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b6000819050919050565b6111c36111be82610b62565b6111a8565b82525050565b60006111d582856111b2565b6020820191506111e582846111b2565b6020820191508190509392505050565b6000611200826109e1565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82141561123357611232611056565b5b60018201905091905056fea26469706673582212207269756f7e12268cbee607ea9295fb101d5a2c10ff71dcfb55ad7e0f68cc4f7a64736f6c634300080a0033";
